<template>
  <div class="info-box">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="flex-1 overflow-y-auto px-2.5"
    >
      <ul class="grid gap-x-3" style="grid-template-columns: 1fr auto">
        <el-form-item
          label="名称"
          prop="name"
          :rules="[{ required: true, message: '请输入名称', trigger: 'blur' }]"
        >
          <el-input v-model="state.model.name"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch
            v-model="state.model.status"
            active-text="启用"
            inactive-text="禁用"
            inline-prompt
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
      </ul>
      <div
        class="items-center gap-x-3 grid"
        style="grid-template-columns: 32% 1fr 1fr"
      >
        <el-form-item
          label="分类"
          prop="d_supplier_type_id"
          :rules="[{ required: true, message: '请选择分类', trigger: 'blur' }]"
        >
          <el-select
            v-model="state.model.d_supplier_type_id"
            :empty-values="[null, undefined, 0]"
          >
            <el-option
              v-for="item in state.type_data"
              :key="item"
              :label="item.name"
              :value="item.id"
            ></el-option>
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadType"
              >
                刷新
              </el-button>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="协议期">
          <el-date-picker
            v-model="state.model.contract_times"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="YYYY-MM-DD"
          />
        </el-form-item>
        <el-form-item
          label="负责人"
          prop="belonger_id"
          :rules="[
            { required: true, message: '请选择负责人', trigger: 'blur' },
          ]"
        >
          <c_userselect
            v-model="state.model.belonger_id"
            @change:item="
              (item) => {
                state.model.belonger_department_id = item.department_id;
              }
            "
          />
        </el-form-item>
      </div>
      <ul
        class="items-center gap-x-3 grid"
        style="grid-template-columns: 32% auto 1fr"
      >
        <el-form-item
          label="联系人"
          prop="contact_name"
          :rules="[
            { required: true, message: '请输入联系人', trigger: 'blur' },
          ]"
        >
          <el-input v-model="state.model.contact_name"></el-input>
        </el-form-item>
        <el-form-item
          label="称谓"
          prop="contact_title"
          :rules="[{ required: true, message: '请选择称谓', trigger: 'blur' }]"
        >
          <div
            class="rounded px-3 cursor-pointer"
            :class="
              state.model.contact_title == '先生'
                ? ' bg-green-800 text-white'
                : ' text-gray-400 border'
            "
            @click="state.model.contact_title = '先生'"
          >
            先生
          </div>
          <div
            class="rounded px-3 ml-2 cursor-pointer"
            :class="
              state.model.contact_title == '女士'
                ? ' bg-red-600 text-white'
                : ' text-gray-400 border'
            "
            @click="state.model.contact_title = '女士'"
          >
            女士
          </div>
        </el-form-item>
        <el-form-item
          label="联系人电话"
          prop="contact_phone"
          :rules="[
            { required: true, message: '请输入联系人电话', trigger: 'blur' },
            { validator: $phone_rules, trigger: 'blur' },
          ]"
        >
          <el-input v-model="state.model.contact_phone"></el-input>
        </el-form-item>
      </ul>
      <el-form-item label="组织机构代码">
        <el-input v-model="state.model.organization_code"></el-input>
      </el-form-item>
      <ul class="grid gap-x-3" style="grid-template-columns: 32% 2fr">
        <el-form-item label="所在地">
          <el-cascader
            v-model="state.model.area"
            :options="area"
            filterable
            :props="{
              value: 'name',
              label: 'name',
            }"
            class="!w-full"
          />
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input v-model="state.model.address"></el-input>
        </el-form-item>
      </ul>
      <el-form-item label="备注">
        <el-input
          v-model="state.model.remark"
          type="textarea"
          :autosize="{
            minRows: 3,
          }"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import area from "@/assets/json/pca-code.json";
import { dic_getSupplierType } from "@/http/data";
import { supplier_detail, supplier_add, supplier_edit } from "@/http/supplier";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      onLoadType();
      if (props.id) {
        supplier_detail(props.id).then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            state.model = data;
            state.model.contract_times = [
              data.contract_time,
              data.contract_time_end,
            ];
            state.model.area = [data.province, data.city, data.district];
          }
        });
      }
    });

    //获取供应商类型
    const onLoadType = () => {
      dic_getSupplierType().then((res) => {
        console.log(res);

        if (res.status == 200) {
          state.type_data = res.data.data;
        }
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (state.model.contract_times?.length == 2) {
            state.model.contract_time = state.model.contract_times[0];
            state.model.contract_time_end = state.model.contract_times[1];
          }

          if (props.id) {
            supplier_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            supplier_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onSubmit,
      area,
    };
  },
};
</script>
<style scoped></style>
